//#region Creating
export function categoriesForCreateGroup(createGroup) {
    if (createGroup == "work") {
        return [
            { entity: "WorkOrder", title: "Work Order", type: "General Maintenance" },
            { entity: "Issue", title: "Reported Issue", type: "Undefined" },
            { entity: "Activity", title: "Activity", type: "Undefined" },
        ]
    } else if (createGroup == "assets") {
        return [
            { entity: "Pipe", systemType: "Main", title: "Main Pipe" },
            { entity: "FixedAsset", systemType: "Main", title: "Other Main Asset" },
            { entity: "Pipe", systemType: "Service", title: "Service Pipe" },
            { entity: "FixedAsset", systemType: "Service", title: "Other Service Asset" },
        ]
    } else if (createGroup == "nhm") {
        return [
            { entity: "Recording", title: "Recording" },
            { entity: "NoiseSource", title: "Noise Source" },
            { entity: "Sensor", title: "Sensor", }
        ]
    }
}

export function protoItemFromProperties(props, dbData) {
    if (props != undefined && props.entity != undefined && props.wpn2_type != undefined) {
        const entity = props.entity;
        const wpn2_type = props.wpn2_type;
        switch (entity) {
            case 'Issue':
            case 'Work':
                const infra = props.infrastructure;
                var item = rootDefaults(entity, wpn2_type, dbData.all, dbData.user_item);
                item['infrastructure'] = infra;
                return item;

            case 'Note':
                var item = rootDefaults(entity, wpn2_type, dbData.all, dbData.user_item);
                // TODO: Is this really user_item?
                item['author_uuid'] = user['uuid'];
                item['editor_uuid'] = user['uuid'];
                item['note_text'] = "New note";
                return item;

            default:
                break;
        }
    }
}
//#endregion

//#region Editing
export function removeRelatedItem(relItem, srcItem) {
    const assocKey = associationsKeyForItem(relItem);
    const relUuid = relItem['uuid'];
    if (assocKey != undefined && relUuid != undefined && srcItem != undefined) {
        var assocUuids = srcItem[assocKey] ?? [];
        const index = assocUuids.indexOf(relUuid);
        if (index >= 0) {
            assocUuids.splice(index, 1);
            srcItem[assocKey] = assocUuids;
        }
    }
    return srcItem;
}
export function addRelatedItem(relItem, srcItem) {
    const assocKey = associationsKeyForItem(relItem);
    const relUuid = relItem['uuid'];
    if (assocKey != undefined && relUuid != undefined && srcItem != undefined && srcItem['uuid'] != undefined) {
        var assocUuids = srcItem[assocKey] ?? [];
        if (assocUuids.includes(relUuid) == false && relUuid != srcItem['uuid']) {
            assocUuids.push(relUuid);
            srcItem[assocKey] = assocUuids;
        }
    }
    return srcItem;
}

function associationsKeyForItem(item) {
    if (item != undefined && item['entity'] != undefined) {
        const relEntity = item['entity'];
        const assocInfo = { 
            'Activity': "activity_uuids",
            'FixedAsset': "fixed_asset_uuids",
            'Image': "image_uuids",
            'Issue': "issue_uuids",
            'NoiseSource': "noise_source_uuids",
            'Pipe': "pipe_uuids",
            'Sensor': "sensor_uuids",
            'WorkOrder': "work_order_uuids"
        };
        return assocInfo[relEntity];
    }
}
//#endregion

export function categoriesForAttribute(attr, entity) {
    switch (attr) {
        case 'priority':
            return [
                { value: "Normal", title: "Normal" },
                { value: "Low", title: "Low" },
                { value: "Medium", title: "Medium" },
                { value: "High", title: "High" },
            ];
        case 'status':
            if (entity == 'Activity' || entity == 'Work') {
                return [
                    { value: "Scheduled", title: "Scheduled" },
                    { value: "Started", title: "Started" },
                    { value: "Completed", title: "Completed" },
                ]
            } else if (entity == 'Issue') {
                return [
                    { value: "Reported", title: "Reported" },
                    { value: "Resolved", title: "Resolved" },
                ]
            }
            break;
        case 'wpn2_type':
            if (entity == 'Work') {
                return [
                    { value: "General Maintenance", title: "General Maintenance" },
                    { value: "Leak Survey", title: "Leak Survey" },
                    { value: "Hydrant Flushing", title: "Hydrant Flushing" },
                    { value: "Valve Exercising", title: "Valve Exercising" },
                    { value: "Painting", title: "Painting" },
                ]
            }
            break;
        default:
            break;
    }
    return [];
}
